import React from "react";


import reactImage from "../assets/react.png";
import node from "../assets/node.png";
import sqlz from "../assets/sqlz.png"

import tailwind from "../assets/tailwind.png";
import mongo from "../assets/mongo.png"
import skt from "../assets/skt.png";
import ml2 from "../assets/machine-learning.png";
import hcj from "../assets/hcj.png"
const Experiencs = () => {
  const techs = [
    {
      id: 1,
      src: hcj,
      title: "HTML/CSS/JavaScript",
      style: "shadow-orange-500",
    },

    {
      id: 4,
      src: reactImage,
      title: "React",
      style: "shadow-blue-600",
    },
    {
      id: 5,
      src: tailwind,
      title: "Tailwind",
      style: "shadow-sky-400",
    },
    {
      id: 6,
      src: node,
      title: "Node JS",
      style: "shadow-green-500",
    },
    {
      id: 7,
      src: ml2,
      title: "Machine-Learning",
      style: "shadow-pink-400",
    },
    {
        id:9,
        src:skt,
        title:"SvelteKit",
        style:"shadow-orange-500",
    },
    {
        id:10,
        src:sqlz,
        title:"Sequelize",
        style:"shadow-blue-400"
        
    },
    {
        id:11,
        src:mongo,
        title:"Mongo DB",
        style:"shadow-green-400"

    }
  ];

  return (
    <div
      name="experience"
      className="bg-gradient-to-b from-gray-800 to-black   pt-20 "
    >
      <div className="max-w-screen-lg mx-auto p-4 flex flex-col justify-center w-full max-h-200 text-white">
        <div>
          <p className="text-4xl font-bold border-b-4 border-gray-500 p-2 inline">
            Skills
          </p>
          <p className="py-6">These are the technologies I've worked with</p>
        </div>

        <div className="w-full grid grid-cols-2 sm:grid-cols-3 gap-8 text-center py-8 px-12 sm:px-0">
          {techs.map(({ id, src, title, style }) => (
            <div
              key={id}
              className={`shadow-md hover:scale-105 duration-500 py-2 rounded-lg ${style}`}
            >
              <img src={src} alt="" className="w-20 mx-auto" />
              <p className="mt-4">{title}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Experiencs;